import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { useFetch } from '../useFetch'
import { useAuth } from '../../contexts/AuthContext'

import { CONFIG } from '../../config'
import { CourtModel } from '../../types/court/court'
import { ApiError } from '../../types/exception/errorStatus'
import { getErrorMessage } from '../../utils/exception/exceptionUtils'

export function useCreateCourt() {
  const { t } = useTranslation(['courts', 'exceptions'])
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)
  const [success, setSuccess] = useState<string | null>(null)
  const { authInfo } = useAuth()
  const { poster } = useFetch(authInfo?.accessToken, authInfo?.refreshToken)

  const resetState = () => {
    setLoading(false)
    setError(null)
    setSuccess(null)
  }

  const createCourt = async (court: CourtModel) => {
    setLoading(true)
    try {
      const data = await poster<CourtModel>(
        `${CONFIG.BOUNCE_API}/api/v1/management/courts`,
        court,
        'application/json'
      )
      if (data) {
        setSuccess(t('courts:courts.court.successfully-created'))
        setError(null)
        return data
      }
    } catch (error) {
      console.log(error)
      if (error instanceof ApiError) {
        const translatedMessage = getErrorMessage(error.data)
        setError(translatedMessage)
      } else setError(t('exceptions:unknown'))
    } finally {
      setLoading(false)
    }
  }

  return { createCourt, loading, error, success, resetState }
}
